/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Icon from '@mui/material/Icon'

// Material Dashboard 2 React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

// Images
import { useAppServices } from 'hook/services'
import { useState, useEffect } from 'react'
import MDButton from 'components/MDButton'
import { useLocation, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import Category from '../subCategory/create'
import MoveSubCategory from '../subCategory/MoveSubCategory'

export default function data() {
  const { state } = useLocation()
  const { view_category, categories } = state
  const AppService = useAppServices()
  const Navigate = useNavigate()
  const [loader, setLoader] = useState(true)
  const [SubCategory, setSubCategory] = useState([])
  const [selected, setSelected] = useState()
  const [open, setOpen] = useState(false)

  const handleDelete = async (id, idx) => {
    Swal.fire({
      title: 'Warning',
      text: 'Are you sure you want to delete?',
      icon: 'warning',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Yes',
    }).then(async (res) => {
      if (!res.isConfirmed) return
      const { response } = await AppService.docs_sub_category.delete({
        query: `_id=${id}`,
        toaster: true,
      })
      if (response) {
        SubCategory.splice(idx, 1)
        setSubCategory([...SubCategory])
      }
    })
  }
  const handleOnClick = (item, idx) => {
    // console.log(item)
    setOpen(idx)
    setSelected(item)
  }
  const handleClose = () => {
    setOpen(false)
  }
  const getDocsSubCat = async () => {
    const { response } = await AppService.docs_sub_category?.filter({
      query: `category=${view_category._id}`,
    })
    // console.log(response, 'response')
    if (response) setSubCategory(response.data)
    setLoader(false)
  }
  const onLoad = () => {
    // alert(state._id)
    getDocsSubCat()
  }
  useEffect(onLoad, [])

  return {
    getDocsSubCat: getDocsSubCat,
    columns: [
      { Header: '', accessor: 'order', width: '10%', align: 'left' },
      { Header: 'title', accessor: 'title', width: '30%', align: 'left' },
      { Header: 'action', accessor: 'action', align: 'center' },
    ],

    rows: SubCategory.map((item, idx) => ({
      order: (
        <MDBox sx={{ cursor: 'pointer' }}>
          <Icon>menu</Icon>
        </MDBox>
      ),
      title: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {' '}
          {item.name}{' '}
        </MDTypography>
      ),

      action: (
        <>
          <MDButton
            onClick={() => handleOnClick(item, idx)}
            variant="gradient"
            color="warning"
            style={{ marginRight: '10px' }}
          >
            Edit{' '}
          </MDButton>
          <MDButton
            variant="gradient"
            color="warning"
            style={{ marginRight: '10px' }}
            onClick={() => handleDelete(item._id, idx)}
          >
            delete
          </MDButton>
          <MDButton
            variant="gradient"
            color="warning"
            style={{ marginRight: '10px' }}
            onClick={() => Navigate('./docsinsight', { state: item })}
          >
            view
          </MDButton>
          <MoveSubCategory data={item} handleRefresh={getDocsSubCat} />
          {selected == item && (
            <Category
              category={selected}
              open={open === idx}
              onClose={handleClose}
              handleRefresh={getDocsSubCat}
            />
          )}
        </>
      ),
    })),
  }
}
